import { useBreadcrumb } from 'react-instantsearch';
import { ChevronIcon, colors, H2 } from '@commonsku/styles';
import { skuFont } from '../helpers/styles';

function CustomBreadcrumb({ ...props }) {
  const { items, refine, createURL } = useBreadcrumb(props);

  const homeItem = {
    label: 'Connected+ Products',
    value: null,
  };

  const breadcrumbItems = items && items.length > 0 ? [homeItem, ...items] : [];
  return (
    <div style={{ display: 'flex', display: 'flex', alignItems: 'center', gap: 5, padding: 0, marginBottom: '1rem' }}>
      {breadcrumbItems.map((item, index) => {
        const isLast = index === breadcrumbItems.length - 1;

        return (
          <React.Fragment key={item.value}>
            {isLast ? (
              <H2 style={{ marginBottom: 0, fontFamily: skuFont }}>{item.label}</H2>
            ) : (
              <H2 href={createURL(item.value)}
                onClick={(e) => {
                  e.preventDefault();
                  refine(item.value);
                }} style={{ color: colors.primary1['65'], marginBottom: 0, cursor: 'pointer', fontFamily: skuFont }}
              >{item.label}</H2>
            )}
            {!isLast && <ChevronIcon direction="right" size='large' color={colors.neutrals['60']} />}
          </React.Fragment>
        );
      })}
    </div>
  );
}

export default CustomBreadcrumb;